import type { TextBoxColors } from 'atoms/TextBox'
import type { IContainerHeaderProps } from './ContainerHeader'

import { styled } from '@linaria/react'
import {
  ContainerHeaderAlignItems,
  ContainerHeaderColumnGap,
  ContainerHeaderDirection,
  ContainerHeaderJustifyContent,
  ContainerHeaderRowGap,
} from './ContainerHeader.h'

export const ContainerHeaderSC = styled.div<
  Omit<IContainerHeaderProps, 'color'> & { colorDefault?: TextBoxColors }
>`
  display: flex;
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  flex-direction: ${({ direction }) =>
    direction || ContainerHeaderDirection.Row};
  align-items: ${({ alignItems }) =>
    alignItems || ContainerHeaderAlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || ContainerHeaderJustifyContent.FlexStart};
  row-gap: ${({ rowGap }) =>
    `var(${rowGap || ContainerHeaderRowGap.INDENT_20})`};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || ContainerHeaderColumnGap.INDENT_40})`};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'inherit'};
`

export const ContainerHeaderWithDescriptionSC = styled.div`
  display: flex;
  flex-direction: column;
`
